import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ToasterService } from "@shared/services/toaster.service";
import { LogService } from "@shared/services/log.service";
import {
    AdminHookshotJiraBridgeManageSelfhostedComponent,
    ManageSelfhostedHookshotJiraBridgeDialogContext
} from "./manage-selfhosted/manage-selfhosted.component";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FE_HookshotJiraBridge } from "@shared/models/hookshot_jira";
import { AdminHookshotJiraApiService } from "@shared/services/admin/admin-hookshot-jira-api.service";
import { SpinnerComponent } from "../../../elements/spinner/spinner.component";
import { IboxComponent } from "../../../elements/ibox/ibox.component";


@Component({
    templateUrl: "./hookshot-jira.component.html",
    styleUrls: ["./hookshot-jira.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SpinnerComponent, IboxComponent, TranslatePipe]
})
export class AdminHookshotJiraBridgeComponent implements OnInit {

    public isLoading = true;
    public isUpdating = false;
    public configurations: FE_HookshotJiraBridge[] = [];

    constructor(private readonly hookshotApi: AdminHookshotJiraApiService,
        private readonly toaster: ToasterService,
        private readonly modal: NgbModal,
        public translate: TranslateService,
        private readonly logService: LogService,
    ) {
        this.translate = translate;
    }

    public ngOnInit() {
        this.reload().then(() => this.isLoading = false);
    }

    private async reload(): Promise<any> {
        try {
            this.configurations = await this.hookshotApi.getBridges();
        } catch (err) {
            this.logService.error(err);
            this.translate.get('Error loading bridges').subscribe((res: string) => {
                this.toaster.pop("error", res);
            });
        }
    }

    public addSelfHostedBridge() {
        const selfhostedRef = this.modal.open(AdminHookshotJiraBridgeManageSelfhostedComponent, {
            backdrop: 'static',
            size: 'lg',
        });
        selfhostedRef.result.then(async () => {
            try {
                await this.reload();
            } catch (err) {
                this.logService.error(err);
                this.translate.get('Failed to get an updated Jira bridge list').subscribe((res: string) => {
                    this.toaster.pop("error", res);
                });
            }
        })
        const selfhostedInstance = selfhostedRef.componentInstance as ManageSelfhostedHookshotJiraBridgeDialogContext;
        selfhostedInstance.provisionUrl = '';
        selfhostedInstance.sharedSecret = '';
    }

    public editBridge(bridge: FE_HookshotJiraBridge) {
        const selfhostedRef = this.modal.open(AdminHookshotJiraBridgeManageSelfhostedComponent, {
            backdrop: 'static',
            size: 'lg',
        });
        selfhostedRef.result.then(async () => {
            try {
                await this.reload();
            } catch (err) {
                this.logService.error(err);
                this.translate.get('Failed to get an updated Jira bridge list').subscribe((res: string) => {
                    this.toaster.pop("error", res);
                });
            }
        })
        const selfhostedInstance = selfhostedRef.componentInstance as ManageSelfhostedHookshotJiraBridgeDialogContext;
        selfhostedInstance.provisionUrl = bridge.provisionUrl;
        selfhostedInstance.sharedSecret = bridge.sharedSecret;
        selfhostedInstance.bridgeId = bridge.id;
        selfhostedInstance.isAdding = !bridge.id;
    }
}
